import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import './UygunRandevuBulucu.css';

// RANDEVU MODÜLÜ — UYGUN RANDEVU SAATİ BULUCU (kullanıcı talebi: 2026-09-21).
// VB6 karşılığı: Randevu_VB6\YOL_GOSTERICI_1.frm. Düzen, renkler ve hücre metinleri VB6 ile aynı:
// üstte filtre şeridi (Tarih / Üst Kurum / Hizmet Grubu / Hizmet Adı), ortada 09:00–23:00 arası
// 15 dakikalık doluluk matrisi, altta renk açıklamaları.
//
// VB6'dan BİLEREK FARKLI olanlar:
//   - Seçili hücre görünür biçimde işaretlenir (VB6'da HighLight=0 olduğu için belli olmuyordu).
//   - Hedef yalnızca BOŞ hücrede alınır (VB6 gri/lacivert/pembe hücrede de izin veriyordu).
//   - Uzman sütunları ada göre sıralı (VB6'da sıra rastgeleydi).
//   - Tüm gün planı/izin/randevu verisi tek istekte gelir (VB6 binlerce sorgu atıyordu).

const RENK = {
  bos: { bg: '#FFFFFF', fg: '#000000', ad: 'BOŞ' },
  parttime: { bg: '#C0FFC0', fg: '#000000', ad: 'Part Time Personel' },
  plandisi: { bg: '#FF8080', fg: '#000000', ad: 'Çalışma planı dışı' },
  globalyasak: { bg: '#0000C0', fg: '#FFFFFF', ad: 'Bu Saatlerde Çalışmıyor' },
  kapali: { bg: '#808080', fg: '#FFFFFF', ad: 'KAPALI' },
  doludiger: { bg: '#FF8080', fg: '#000000', ad: 'Dolu DİĞER' },
  dolupilates: { bg: '#FFC0FF', fg: '#000000', ad: 'Dolu Pilates' },
  dolumanuel: { bg: '#C0FFFF', fg: '#000000', ad: 'Dolu Manuel' },
  yarimgun: { bg: '#FF80FF', fg: '#000000', ad: 'Yarım Gün İzinli' },
  // VB6'da YOK (kullanıcı talebi: 2026-09-23): o saate randevu verilse uzmanın günlük
  // mesaisi 10 saati aşacak — randevu ekranı zaten reddediyor, burada da boş gösterilmiyor.
  mesaidoldu: { bg: '#E0A030', fg: '#000000', ad: '10 Saat Mesai Doldu' },
};
const LEGEND = ['bos', 'kapali', 'yarimgun', 'globalyasak', 'doludiger', 'dolupilates', 'dolumanuel', 'parttime', 'plandisi', 'mesaidoldu'];

const bugunIso = () => new Date().toISOString().slice(0, 10);
const trTarih = (d) => (d ? `${String(d).slice(8, 10)}.${String(d).slice(5, 7)}.${String(d).slice(0, 4)}` : '');

export default function UygunRandevuBulucu() {
  const navigate = useNavigate();
  const [secenek, setSecenek] = useState(null);
  const [tarih, setTarih] = useState(bugunIso());
  const [ustKurumKod, setUstKurumKod] = useState(0);
  const [ne, setNe] = useState(null);                 // hizmet grubu
  const [hizmetler, setHizmetler] = useState([]);
  const [hizmetKod, setHizmetKod] = useState(0);
  const [izgara, setIzgara] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [hata, setHata] = useState('');
  const [bilgi, setBilgi] = useState('');
  const [secili, setSecili] = useState(null);         // { uzman, hucre }
  const [izinPanel, setIzinPanel] = useState(null);   // part-time çalışma izni
  const [kaydediliyor, setKaydediliyor] = useState(false);

  useEffect(() => {
    api.get('/uygunrandevu/secenekler')
      .then(({ data }) => {
        setSecenek(data);
        if (data.ustKurumlar.length > 0) setUstKurumKod(data.ustKurumlar[0].kod);
        if (data.gruplar.length > 0) setNe(data.gruplar[0].ne);
      })
      .catch(err => setHata(err.response?.data?.hata || 'Seçenekler alınamadı.'));
  }, []);

  useEffect(() => {
    if (ne == null) return;
    api.get('/uygunrandevu/grup-hizmetleri', { params: { ne } })
      .then(({ data }) => {
        setHizmetler(data);
        setHizmetKod(data.length > 0 ? data[0].kod : 0);
        if (data.length === 0) setHata('Bu hizmet grubunda tanımlı hizmet yok.');
      })
      .catch(err => {
        setHizmetler([]); setHizmetKod(0);
        setHata(err.response?.data?.hata || 'Hizmet listesi alınamadı.');
      });
  }, [ne]);

  useEffect(() => {
    if (!bilgi) return undefined;
    const z = setTimeout(() => setBilgi(''), 8000);
    return () => clearTimeout(z);
  }, [bilgi]);

  // Filtreler hazır olur olmaz ilk listeyi getir — VB6'da kullanıcı LİSTELE'ye basıyordu,
  // ekran boş açılıyordu. Sonraki filtre değişikliklerinde yine LİSTELE ile yenilenir.
  const [ilkListeYapildi, setIlkListeYapildi] = useState(false);

  const listele = useCallback(async () => {
    if (!ustKurumKod || !hizmetKod) { setHata('Lütfen üst kurumu ve hizmeti seçiniz.'); return; }
    setYukleniyor(true); setHata(''); setSecili(null);
    try {
      const { data } = await api.get('/uygunrandevu/izgara', { params: { tarih, ustKurumKod, hizmetKod } });
      setIzgara(data);
      if (data.uyari) setHata(data.uyari);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Liste alınamadı.');
      setIzgara(null);
    } finally {
      setYukleniyor(false);
    }
  }, [tarih, ustKurumKod, hizmetKod]);

  useEffect(() => {
    if (ilkListeYapildi || !ustKurumKod || !hizmetKod) return;
    setIlkListeYapildi(true);
    listele();
  }, [ilkListeYapildi, ustKurumKod, hizmetKod, listele]);

  const hucreTikla = (uzman, hucre) => {
    setSecili({ uzman, hucre });
    // VB6: yeşil (part-time kapalı) hücreye çift tık → çalışma izni paneli.
    if (hucre.durum === 'parttime' && uzman.partTime) {
      const saatler = secenek?.izinSaatleri || [];
      const i = saatler.indexOf(hucre.saat);
      setIzinPanel({
        uzman, bas: hucre.saat,
        bit: saatler[Math.min(saatler.length - 1, (i < 0 ? 0 : i) + 4)] || hucre.saat,
      });
    }
  };

  // VB6 Command1: hedefi hafızaya al → Randevu Ekranı o uzman ve tarihle açılır.
  const hedefeGit = () => {
    if (!secili) { setHata('Lütfen hedef uzmanı ve saatini seçiniz.'); return; }
    if (secili.hucre.durum !== 'bos') { setHata('Bu saat uygun değil; yalnızca BOŞ (beyaz) hücre seçilebilir.'); return; }
    try {
      localStorage.setItem('randevuHedefi', JSON.stringify({
        dokKod: secili.uzman.kod, uzman: secili.uzman.adi, tarih, saat: secili.hucre.saat, zaman: Date.now(),
      }));
    } catch { /* depolama kapalıysa yönlendirme yine de çalışsın */ }
    navigate('/randevu-ekrani');
  };

  const izinKaydet = async () => {
    if (!izinPanel) return;
    setKaydediliyor(true); setHata('');
    try {
      await api.post('/uygunrandevu/calisma-izni', {
        dokKod: izinPanel.uzman.kod, tarih, bas: izinPanel.bas, bit: izinPanel.bit,
      });
      setBilgi(`${izinPanel.uzman.adi} için ${izinPanel.bas}–${izinPanel.bit} çalışma izni kaydedildi.`);
      setIzinPanel(null);
      await listele();
    } catch (err) {
      setHata(err.response?.data?.hata || 'Çalışma izni kaydedilemedi.');
    } finally {
      setKaydediliyor(false);
    }
  };

  return (
    <div className="yg">
      <div className="yg-serit">
        <h2 className="yg-baslik">🔎 Uygun Randevu Saati Bulucu <span>· Randevu Modülü</span></h2>
        <div className={`yg-durum ${hata ? 'hata' : bilgi ? 'bilgi' : ''}`}>
          {hata || bilgi || 'O gün çalışmayanlar ve tam gün izinliler listeye getirilmemiştir.'}
        </div>
      </div>

      <div className="yg-filtre">
        <span className="yg-etiket">Tarih</span>
        <input type="date" value={tarih} onChange={e => setTarih(e.target.value)} />

        <span className="yg-etiket">Üst Kurum</span>
        <select value={ustKurumKod} onChange={e => setUstKurumKod(Number(e.target.value))}>
          {(secenek?.ustKurumlar || []).map(k => <option key={k.kod} value={k.kod}>{k.adi}</option>)}
        </select>

        <span className="yg-etiket">Hizmet Grubu</span>
        <select value={ne ?? ''} onChange={e => setNe(Number(e.target.value))}>
          {(secenek?.gruplar || []).map(g => <option key={g.ne} value={g.ne}>{g.adi}</option>)}
        </select>

        <span className="yg-etiket">Hizmet Adı</span>
        <select value={hizmetKod} onChange={e => setHizmetKod(Number(e.target.value))}>
          {hizmetler.map(h => <option key={h.kod} value={h.kod}>{h.adi}</option>)}
        </select>

        <button type="button" className="btn btn-primary" onClick={listele} disabled={yukleniyor}>
          {yukleniyor ? 'Listeleniyor...' : '🔄 LİSTELE'}
        </button>
        <button type="button" className="btn btn-secondary" onClick={hedefeGit}
          disabled={!secili || secili.hucre.durum !== 'bos'}
          title={secili ? 'Seçili uzman, tarih ve saati Randevu Ekranı’nda aç' : 'Önce boş bir hücre seçiniz'}>
          🎯 HEDEFE GİT
        </button>
      </div>

      {secili && (
        <div className="yg-secim">
          <b>{secili.uzman.adi}</b> · {trTarih(tarih)} · <b>{secili.hucre.saat}</b> ·{' '}
          {RENK[secili.hucre.durum]?.ad || secili.hucre.durum}
          {secili.hucre.hasta ? ` · ${secili.hucre.hasta}` : ''}
          {secili.hucre.hizmet ? ` (${secili.hucre.hizmet})` : ''}
        </div>
      )}

      {izgara && izgara.uzmanlar.length > 0 && (
        <div className="yg-izgara">
          <table>
            <thead>
              <tr>
                <th className="yg-saat-bas">{trTarih(izgara.tarih)}</th>
                {izgara.uzmanlar.map(u => (
                  <th key={u.kod} title={u.adi}>{u.adi}{u.partTime ? ' (PT)' : ''}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {izgara.slotlar.map((saat, i) => (
                <tr key={saat}>
                  <th className="yg-saat">{saat}</th>
                  {izgara.uzmanlar.map(u => {
                    const h = u.hucreler[i];
                    const r = RENK[h.durum] || RENK.bos;
                    const sec = secili?.uzman.kod === u.kod && secili?.hucre.saat === saat;
                    return (
                      <td key={u.kod}
                        className={`yg-hucre ${sec ? 'secili' : ''} ${h.durum === 'bos' ? 'bos' : ''}`}
                        style={{ background: r.bg, color: r.fg }}
                        title={`${u.adi} · ${saat} · ${r.ad}${h.hasta ? ` · ${h.hasta}` : ''}`}
                        onClick={() => hucreTikla(u, h)}
                        onDoubleClick={() => { hucreTikla(u, h); if (h.durum === 'bos') hedefeGit(); }}>
                        {h.metin}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {izgara && izgara.uzmanlar.length === 0 && !yukleniyor && (
        <div className="empty">{izgara.uyari || 'Bu kriterlerde uzman bulunamadı.'}</div>
      )}

      <div className="yg-legend">
        {LEGEND.map(k => (
          <span key={k} className="yg-legend-oge">
            <i style={{ background: RENK[k].bg }} />{RENK[k].ad}
          </span>
        ))}
        <span className="yg-legend-not">
          BEYAZ hücreye çift tıklarsanız uzmanı, günü ve saati hedef alıp Randevu Ekranı’nı açar ·
          YEŞİL hücreye tıklarsanız part time personele çalışma izni verir.
        </span>
      </div>

      {izinPanel && (
        <div className="yg-modal-zemin" onClick={() => setIzinPanel(null)} role="presentation">
          <div className="yg-modal" onClick={e => e.stopPropagation()} role="presentation">
            <div className="yg-modal-bas">
              <strong>ÇALIŞMA İZNİ</strong>
              <button type="button" onClick={() => setIzinPanel(null)}>✕</button>
            </div>
            <div className="yg-modal-govde">
              <div className="yg-alan"><span>Görev Tarihi</span><b>{trTarih(tarih)}</b></div>
              <div className="yg-alan"><span>Part Time Personel</span><b>{izinPanel.uzman.adi}</b></div>
              <div className="yg-saatler">
                <label><span>Başlangıç</span>
                  <select value={izinPanel.bas} onChange={e => setIzinPanel(p => ({ ...p, bas: e.target.value }))}>
                    {(secenek?.izinSaatleri || []).map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </label>
                <label><span>Bitiş</span>
                  <select value={izinPanel.bit} onChange={e => setIzinPanel(p => ({ ...p, bit: e.target.value }))}>
                    {(secenek?.izinSaatleri || []).map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </label>
              </div>
              <p className="yg-modal-not">
                Bu saat aralığı, personelin o güne özel çalışma penceresidir; kaydedilince ızgarada beyaz (boş) olur.
              </p>
              <div className="yg-modal-alt">
                <button type="button" className="btn btn-secondary" onClick={() => setIzinPanel(null)}>Vazgeç</button>
                <button type="button" className="btn btn-primary" onClick={izinKaydet} disabled={kaydediliyor}>
                  {kaydediliyor ? 'Kaydediliyor...' : 'KAYDET'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
